/** 1.3.0 portal strings, stream P1 (Administration → Media portal, where it reuses portal texts). P1's file. */
export const ADMIN_STRINGS = {
  /** The rights declaration Branding starts with when none is written yet. */
  'admin.rights.default': 'I confirm that I hold, or am authorised by the holders of, all rights needed to deliver these files and for them to be used as agreed.',
  /** The portal's name when Branding leaves it empty. */
  'admin.portalName.default': 'Media portal',
} as const;
